import { Link } from "react-router-dom";
import withLoader from "../../components/layouts/WithLoader";

import Select from "react-select";
import makeAnimated from "react-select/animated";
import { useEffect, useState } from "react";
import SocieteService from "../../services/Societe";
import KPISaleService from "../../services/KPISaleService";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
import DataTablekpisaleproduct from "../../ui/DataTablekpisaleproduct";
import Societe from "../../services/Societe";


const KPISaleProduct = ({ startLoading, stopLoading }) => {
  const [selectedYear, setSelectedYear] = useState(null);
  const [finalYear, setFinalYear] = useState("");
  const [yearsOptions, setYearsOptions] = useState([]);
  const [yearPlaceholder, setYearPlaceholder] = useState("");
  const animatedComponents = makeAnimated();
  const [isClicked, setIsClicked] = useState(false);
  const [monthsOptions, setMonthsOptions] = useState([
    { value: "0", label: "Tous" },
  ]);
  const [monthPlaceholder, setMonthPlaceholder] = useState("");

  const [finalMonth, setFinalMonth] = useState("");

  const [selectedMonth, setSelectedMonth] = useState(null);

  const [minAmount, setMinAmount] = useState(null);
  const [maxAmount, setMaxAmount] = useState(null);

  const [top1, setTop1] = useState(null);
  const [top2, setTop2] = useState(null);

  const [top3, setTop3] = useState(null);
  const [listProducts, setListProducts] = useState([]);
  const [ttQte, setTtQte] = useState(null);

  const [clientId, setClientId] = useState(0);
  const [clientSelectPlaceHolder, setClientSelectPlaceHolder] =
    useState("Tous");
  const [allClients, setAllClients] = useState([{ value: 0, label: "Tous" }]);
  const [clientSelectedOption, setClientSelectedOption] = useState(null);

  const [selectedOption, setSelectedOption] = useState(null);


  // useEffect(() => {
  //   // SocieteService.getFinacialYearsAndMonthsFromSocieteCreationDate()
  //   //   .then((response) => {
  //   //     if (response.data["success"] !== undefined) {
  //   //       const today = new Date();
  //   //       const mm = String(today.getMonth() + 1).padStart(2, "0");
  //   //       const yyyy = today.getFullYear();

  //   //       setFinalYear(yyyy);
  //   //       setYearPlaceholder(yyyy);

  //   //       if (mm === "1") {
  //   //         setFinalMonth("1");
  //   //         setMonthPlaceholder("Janvier");
  //   //       } else if (mm === "2") {
  //   //         setFinalMonth("2");
  //   //         setMonthPlaceholder("Février");
  //   //       } else if (mm === "3") {
  //   //         setFinalMonth("3");
  //   //         setMonthPlaceholder("Mars");
  //   //       } else if (mm === "4") {
  //   //         setFinalMonth("4");
  //   //         setMonthPlaceholder("Avril");
  //   //       } else if (mm === "5") {
  //   //         setFinalMonth("5");
  //   //         setMonthPlaceholder("Mai");
  //   //       } else if (mm === "6") {
  //   //         setFinalMonth("6");
  //   //         setMonthPlaceholder("Juin");
  //   //       } else if (mm === "7") {
  //   //         setFinalMonth("7");
  //   //         setMonthPlaceholder("Juiliet");
  //   //       } else if (mm === "8") {
  //   //         setFinalMonth("8");
  //   //         setMonthPlaceholder("Aout");
  //   //       } else if (mm === "9") {
  //   //         setFinalMonth("9");
  //   //         setMonthPlaceholder("Septembre");
  //   //       } else if (mm === "10") {
  //   //         setFinalMonth("10");
  //   //         setMonthPlaceholder("Octobre");
  //   //       } else if (mm === "11") {
  //   //         setFinalMonth("11");
  //   //         setMonthPlaceholder("Novembre");
  //   //       } else if (mm === "12") {
  //   //         setFinalMonth("12");
  //   //         setMonthPlaceholder("Decemebre");
  //   //       }

  //   //       const yearsOptions = response.data["success"].years.map(
  //   //         (year, index) => ({
  //   //           value: year,
  //   //           label: year,
  //   //         })
  //   //       );
  //   //       setYearsOptions([...yearsOptions]);

  //   //       const orderedMonth = response.data["success"].months.map((month) =>
  //   //         parseInt(month)
  //   //       );
  //   //       console.log(orderedMonth);
  //   //       orderedMonth.sort((a, b) => a - b);
  //   //       console.log(orderedMonth);

  //   //       const monthsOptions = orderedMonth.map((month) => {
  //   //         const monthLabel = month;
  //   //         switch (month) {
  //   //           case 1:
  //   //             return { value: monthLabel, label: "Janvier" };
  //   //           case 2:
  //   //             return { value: monthLabel, label: "Février" };
  //   //           case 3:
  //   //             return { value: monthLabel, label: "Mars" };
  //   //           case 4:
  //   //             return { value: monthLabel, label: "Avril" };
  //   //           case 5:
  //   //             return { value: monthLabel, label: "Mai" };
  //   //           case 6:
  //   //             return { value: monthLabel, label: "Juin" };
  //   //           case 7:
  //   //             return { value: monthLabel, label: "Juillet" };
  //   //           case 8:
  //   //             return { value: monthLabel, label: "Aout" };
  //   //           case 9:
  //   //             return { value: monthLabel, label: "Septembre" };
  //   //           case 10:
  //   //             return { value: monthLabel, label: "Octobre" };
  //   //           case 11:
  //   //             return { value: monthLabel, label: "Novembre" };
  //   //           case 12:
  //   //             return { value: monthLabel, label: "Decembre" };
  //   //           default:
  //   //             return null;
  //   //         }
  //   //       });

  //   //       console.log(monthsOptions);
  //   //       setMonthsOptions([...monthsOptions]);
  //   //       // remplissageYearsAndMonthsOption();
  //   //     }
  //   //   })
  //   //   .catch((error) => {
  //   //     console.log("error " + error);
  //   //   });
  //        SocieteService.getFinacialYearsAndMonthsFromSocieteCreationDate()
  //             .then((response) => {
  //               if (response.data["success"] !== undefined) {
                  
  //                 const today = new Date();
  //                 const mm = String(today.getMonth() + 1).padStart(2, "0");
  //                 const yyyy = today.getFullYear();
              
  //                 setFinalYear(yyyy);
  //                 setYearPlaceholder(yyyy);
              
  //                 if (mm === "01") {
  //                   setFinalMonth("01");
  //                   setMonthPlaceholder("Janvier");
  //                 } else if (mm === "02") {
  //                   setFinalMonth("02");
  //                   setMonthPlaceholder("Février");
  //                 } else if (mm === "03") {
  //                   setFinalMonth("03");
  //                   setMonthPlaceholder("Mars");
  //                 } else if (mm === "04") {
  //                   setFinalMonth("04");
  //                   setMonthPlaceholder("Avril");
  //                 } else if (mm === "05") {
  //                   setFinalMonth("05");
  //                   setMonthPlaceholder("Mai");
  //                 } else if (mm === "06") {
  //                   setFinalMonth("06");
  //                   setMonthPlaceholder("Juin");
  //                 } else if (mm === "07") {
  //                   setFinalMonth("07");
  //                   setMonthPlaceholder("Juiliet");
  //                 } else if (mm === "08") {
  //                   setFinalMonth("08");
  //                   setMonthPlaceholder("Aout");
  //                 } else if (mm === "09") {
  //                   setFinalMonth("09");
  //                   setMonthPlaceholder("Septembre");
  //                 } else if (mm === "10") {
  //                   setFinalMonth("10");
  //                   setMonthPlaceholder("Octobre");
  //                 } else if (mm === "11") {
  //                   setFinalMonth("11");
  //                   setMonthPlaceholder("Novembre");
  //                 } else if (mm === "12") {
  //                   setFinalMonth("12");
  //                   setMonthPlaceholder("Decemebre");
  //                 }
              
  //                 const yearsOptions = response.data["success"].years.map((year, index) => ({
  //                   value: year,
  //                   label: year,
  //                 }));
  //                 setYearsOptions([ ...yearsOptions]);
              
  //                 const orderedMonth = response.data["success"].months.map((month) => parseInt(month));
  //                 console.log(orderedMonth);
  //                 orderedMonth.sort((a, b) => a - b);
  //                 console.log(orderedMonth);
              
  //                 const monthsOptions = orderedMonth.map((month) => {
  //                   const monthLabel = month < 10 ? `0${month}` : `${month}`;
  //                   switch (month) {
  //                     case 1:
  //                       return { value: monthLabel, label: "Janvier" };
  //                     case 2:
  //                       return { value: monthLabel, label: "Février" };
  //                     case 3:
  //                       return { value: monthLabel, label: "Mars" };
  //                     case 4:
  //                       return { value: monthLabel, label: "Avril" };
  //                     case 5:
  //                       return { value: monthLabel, label: "Mai" };
  //                     case 6:
  //                       return { value: monthLabel, label: "Juin" };
  //                     case 7:
  //                       return { value: monthLabel, label: "Juillet" };
  //                     case 8:
  //                       return { value: monthLabel, label: "Aout" };
  //                     case 9:
  //                       return { value: monthLabel, label: "Septembre" };
  //                     case 10:
  //                       return { value: monthLabel, label: "Octobre" };
  //                     case 11:
  //                       return { value: monthLabel, label: "Novembre" };
  //                     case 12:
  //                       return { value: monthLabel, label: "Decembre" };
  //                     default:
  //                       return null;
  //                   }
  //                 });
              
  //                 console.log(monthsOptions);
  //                 setMonthsOptions([{ value: "0", label: "Tous" }, ...monthsOptions]);
  //                 // remplissageYearsAndMonthsOption();
  //               }
  //             })
  //             .catch((error) => {
  //               // setAlertMessage("error " + error);
  //             });
  // }, []);


   useEffect(() => {
   startLoading();
     Societe.getSocietesClients("CLIENT", "CLIENT", 1, 0)
         .then((reponse) => {
          reponse.data["Societe"]&& reponse.data["Societe"].map((element, i) => {
            let exist = false;
            if (allClients.length !== 0) {
              for (let index = 0; index < allClients.length; index++) {
                if (allClients[index].value === element?.id) {
                  exist = true;
                  break;
                }
              }
            }
    
            if (element?.id !== undefined && exist === false) {
              setAllClients((oldArray) => [
                ...oldArray,
                { value: element.id, label: element.title },
              ]);
            }
          });
         })
         .catch((e) => {
          
         }).finally(() => {
          stopLoading();
         });
         SocieteService.getFinacialYearsAndMonthsFromSocieteCreationDate()
              .then((response) => {
                if (response.data["success"] !== undefined) {
                  
                  const today = new Date();
                  const mm = String(today.getMonth() + 1).padStart(2, "0");
                  const yyyy = today.getFullYear();
              
                  setFinalYear(yyyy);
                  setYearPlaceholder(yyyy);
              
                  if (mm === "01") {
                    setFinalMonth("01");
                    setMonthPlaceholder("Janvier");
                  } else if (mm === "02") {
                    setFinalMonth("02");
                    setMonthPlaceholder("Février");
                  } else if (mm === "03") {
                    setFinalMonth("03");
                    setMonthPlaceholder("Mars");
                  } else if (mm === "04") {
                    setFinalMonth("04");
                    setMonthPlaceholder("Avril");
                  } else if (mm === "05") {
                    setFinalMonth("05");
                    setMonthPlaceholder("Mai");
                  } else if (mm === "06") {
                    setFinalMonth("06");
                    setMonthPlaceholder("Juin");
                  } else if (mm === "07") {
                    setFinalMonth("07");
                    setMonthPlaceholder("Juiliet");
                  } else if (mm === "08") {
                    setFinalMonth("08");
                    setMonthPlaceholder("Aout");
                  } else if (mm === "09") {
                    setFinalMonth("09");
                    setMonthPlaceholder("Septembre");
                  } else if (mm === "10") {
                    setFinalMonth("10");
                    setMonthPlaceholder("Octobre");
                  } else if (mm === "11") {
                    setFinalMonth("11");
                    setMonthPlaceholder("Novembre");
                  } else if (mm === "12") {
                    setFinalMonth("12");
                    setMonthPlaceholder("Decemebre");
                  }
              
                  const yearsOptions = response.data["success"].years.map((year, index) => ({
                    value: year,
                    label: year,
                  }));
                  setYearsOptions([ ...yearsOptions]);
              
                  const orderedMonth = response.data["success"].months.map((month) => parseInt(month));
                  console.log(orderedMonth);
                  orderedMonth.sort((a, b) => a - b);
                  console.log(orderedMonth);
              
                  const monthsOptions = orderedMonth.map((month) => {
                    const monthLabel = month < 10 ? `0${month}` : `${month}`;
                    switch (month) {
                      case 1:
                        return { value: monthLabel, label: "Janvier" };
                      case 2:
                        return { value: monthLabel, label: "Février" };
                      case 3:
                        return { value: monthLabel, label: "Mars" };
                      case 4:
                        return { value: monthLabel, label: "Avril" };
                      case 5:
                        return { value: monthLabel, label: "Mai" };
                      case 6:
                        return { value: monthLabel, label: "Juin" };
                      case 7:
                        return { value: monthLabel, label: "Juillet" };
                      case 8:
                        return { value: monthLabel, label: "Aout" };
                      case 9:
                        return { value: monthLabel, label: "Septembre" };
                      case 10:
                        return { value: monthLabel, label: "Octobre" };
                      case 11:
                        return { value: monthLabel, label: "Novembre" };
                      case 12:
                        return { value: monthLabel, label: "Decembre" };
                      default:
                        return null;
                    }
                  });
              
                  console.log(monthsOptions);
                  setMonthsOptions([{ value: "0", label: "Tous" }, ...monthsOptions]);
                  // remplissageYearsAndMonthsOption();
                }
              })
              .catch((error) => {
                // setAlertMessage("error " + error);
              });
  }, []);


  const handleYearChange = (selectedOption) => {
    setSelectedYear(selectedOption);
    setFinalYear(selectedOption.label);
    console.log(`Option selected:`, selectedOption);
  };

  const getKPISale = (e) => {
    setIsClicked(true);
    startLoading();
    KPISaleService.getProductsSaleByMonthByYear(
      getCurrentUserId(),
      finalMonth,
      finalYear,clientId
    )
      .then((response) => {
        if (response.data) {
          setMinAmount(response.data?.minAmount);
          setMaxAmount(response.data?.maxAmount);
          setTop1(response.data?.top1);
          setTop2(response.data?.top2);
          setTop3(response.data?.top3);
          setListProducts(response.data?.list);
          setTtQte(response.data?.ttQte);
        }

      })
      .catch((error) => {
        console.log("error: " + error);
      })
      .finally(() => {
        stopLoading();
      });

    // KPISaleService.getBDCToByYear(getCurrentUserId(), finalYear)
    //   .then((response) => {
    //     setToBDCByYear(response.data);
    //   })
    //   .catch((error) => {
    //     console.log("error: " + error);
    //   })
    //   .finally(() => {
    //     stopLoading();
    //   });
    // KPISaleService.numberFacturePayed(getCurrentUserId(), finalYear)
    //   .then((response) => {
    //     setNbrFacturesPayed(response.data[0]);
    //     setNbrFacturesNotPayed(response.data[1]);
    //   })
    //   .catch((error) => {
    //     console.log("error: " + error);
    //   })
    //   .finally(() => {
    //     stopLoading();
    //   });

    // KPISaleService.numberBDCMonthsInYear(getCurrentUserId(), finalYear)
    //   .then((response) => {
    //     setNbrBDCMonthsInYear(response.data);
    //   })
    //   .catch((error) => {
    //     console.log("error: " + error);
    //   })
    //   .finally(() => {
    //     stopLoading();
    //   });

    // KPISaleService.numberDevisMonthsInYear(getCurrentUserId(), finalYear)
    //   .then((response) => {
    //     setNbrDevisMonthsInYear(response.data);
    //   })
    //   .catch((error) => {
    //     console.log("error: " + error);
    //   })
    //   .finally(() => {
    //     stopLoading();
    //   });
  };

  const handleMonthChange = (selectedOption) => {
    setSelectedMonth(selectedOption);
    setFinalMonth(selectedOption.value);
    console.log(`Option selected:`, selectedOption.value);
  };

  const cardsTop1 = () => {
    if (isClicked && top1 !== null) {
      return (
        <div className="col-md-4 col-sm-6 col-12">
          <div className="info-box">
            <span className="info-box-icon bg-info">
              <i class="fa-solid fa-1"></i>{" "}
            </span>
            <div className="info-box-content">
              <span className="info-box-text">{top1?.barcode}</span>
              <span className="info-box-text">{top1?.name}</span>

              <span className="info-box-number">{top1?.totalAmountSellingPrice}</span>
            </div>
          </div>
        </div>
      );
    }
  };
  const cardsTop2 = () => {
    if (isClicked && top2 !== null) {
      return (
        <div className="col-md-4 col-sm-6 col-12">
          <div className="info-box">
            <span className="info-box-icon bg-info">
              <i class="fa-solid fa-2"></i>
            </span>
            <div className="info-box-content">
              <span className="info-box-text">{top2?.barcode}</span>
              <span className="info-box-text">{top2?.name}</span>

              <span className="info-box-number">{top2?.totalAmountSellingPrice}</span>
            </div>
          </div>
        </div>
      );
    }
  };

  const cardsTop3 = () => {
    if (isClicked && top3 !== null) {
      return (
        <div className="col-md-4 col-sm-6 col-12">
          <div className="info-box">
            <span className="info-box-icon bg-info">
              <i class="fa-solid fa-3"></i>{" "}
            </span>
            <div className="info-box-content">
              <span className="info-box-text">{top3?.barcode}</span>
              <span className="info-box-text">{top3?.name}</span>

              <span className="info-box-number">{top3?.totalAmountSellingPrice}</span>
            </div>
          </div>
        </div>
      );
    }
  };

  const minAmountCard = () => {
    if (isClicked && minAmount !== null) {
      return (
        <div className="col-md-4 col-sm-6 col-12">
          <div className="info-box">
            <span className="info-box-icon bg-info">
              <i class="fa-solid fa-sack-xmark"></i>{" "}
            </span>
            <div className="info-box-content">
              <span className="info-box-text">Min </span>
              {/* <span className="info-box-text">{minAmount}</span> */}

              <span className="info-box-number">{minAmount}</span>
            </div>
          </div>
        </div>
      );
    }
  };




  const maxAmountCard = () => {
    if (isClicked && maxAmount !== null) {
      return (
        <div className="col-md-4 col-sm-6 col-12">
          <div className="info-box">
            <span className="info-box-icon bg-info">
              <i class="fa-solid fa-sack-xmark"></i>{" "}
            </span>
            <div className="info-box-content">
              <span className="info-box-text">Max </span>

              <span className="info-box-number">{maxAmount}</span>
            </div>
          </div>
        </div>
      );
    }
  };
  function moyenneDecimal(minAmount, maxAmount) {
    return Math.round((minAmount + maxAmount) / 2);
  }

  const moyenAmountCard = () => {
    if (isClicked && maxAmount !== null) {
      return (
        <div className="col-md-4 col-sm-6 col-12">
          <div className="info-box">
            <span className="info-box-icon bg-info">
              <i class="fa-solid fa-sack-xmark"></i>{" "}
            </span>
            <div className="info-box-content">
              <span className="info-box-text">Moyenne </span>

              <span className="info-box-number">
                {moyenneDecimal(minAmount, maxAmount)}
              </span>
            </div>
          </div>
        </div>
      );
    }
  };
    const onChangeSelectedClient = (selectedOptionn) => {
    setSelectedOption();
    setClientId(selectedOptionn.value);
    setClientSelectPlaceHolder(selectedOptionn.label);
  };


  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-6"></div>
            <div className="col-md-6">
              <ol class="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  {" "}
                  <Link to="/" style={{ color: "black" }}>
                    Home
                  </Link>
                </li>

                <li
                  className="breadcrumb-item active"
                  style={{ color: "black" }}
                >
                  Les KPI de Vente
                </li>
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section className="content ">
        <div className="container-fluid">
          <div className="row mb-2">
            {" "}
            <div className="col-sm-12">
              <div class="card">
                <div className="card-header">
                  <h3 className="card-title">Choisir un an</h3>
                </div>
                <div class="card-body">
                  <div className="row mb-2">
                      <div className="col-sm-4">
                      <div className="form-group">
                        <label htmlFor="inputClientCompany">
                          Choisir le Client
                        </label>
                        <Select
                          closeMenuOnSelect={true}
                          components={animatedComponents}
                          defaultValue={clientSelectedOption}
                          onChange={onChangeSelectedClient}
                          options={allClients}
                          placeholder={clientSelectPlaceHolder}
                        />
                      </div>
                    </div>

                    <div className="form-group col-4 col-sm-4">
                      <div>
                        <label>Choisir l'année </label>
                        <Select
                          value={selectedYear}
                          closeMenuOnSelect={true}
                          components={animatedComponents}
                          options={yearsOptions}
                          onChange={handleYearChange}
                          defaultValue={selectedYear}
                          placeholder={yearPlaceholder}
                        />
                      </div>
                    </div>
                    <div className="form-group col-4 col-sm-4">
                      <div>
                        <label>Choisir le mois</label>
                        <Select
                          value={selectedMonth}
                          closeMenuOnSelect={true}
                          components={animatedComponents}
                          options={monthsOptions}
                          onChange={handleMonthChange}
                          defaultValue={selectedMonth}
                          placeholder={monthPlaceholder}
                        />
                      </div>
                    </div>
                  </div>{" "}
                </div>

                <div className="card-footer">
                  <button
                    type="submit"
                    onClick={getKPISale}
                    className="btn btn-dark float-right"
                  >
                    Valider
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="content ">
        <div className="container-fluid">
          <div className="row mb-2">
            {cardsTop1()}
            {cardsTop2()}
            {cardsTop3()}
          </div>
          <div className="row mb-2">
            {minAmountCard()}
            {maxAmountCard()}
            {moyenAmountCard()}
          </div>
      
          <DataTablekpisaleproduct listProducts={listProducts} isClicked={isClicked} finalMonth={finalMonth} finalYear={finalYear} ttQte={ttQte} />
        </div>
      </section>
    </div>
  );
};
export default withLoader(KPISaleProduct);
